export default {
    THEME_CHANGE: "THEME_CHANGE",
    THEME_INIT: "THEME_INIT",
}
